import { Button, FormControl, TextField } from '@mui/material';
import React, { useRef, useState } from 'react';
import propTypes from 'prop-types';
import { Box } from '@mui/system';

function NewStatePopup(props) {
  const { handleSubmit } = props;
  const [color, setColor] = useState('#ffcc01');
  const [text, setText] = useState('');
  const myRef = useRef();
  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="center">
        <FormControl fullWidth>
          <TextField
            label="Texto"
            name="text"
            value={text}
            onChange={(event) => setText(event.target.value)}
          />
        </FormControl>
        <FormControl>
          <Box
            mx={1}
            sx={{
              width: 35,
              height: 35,
              background: color,
              borderRadius: 2,
            }}
            onClick={() => myRef.current.click()}
          />
          <input
            onChange={(e) => setColor(e.target.value)}
            style={{ position: 'absolute', opacity: 0 }}
            type="color"
            ref={myRef}
          />
        </FormControl>
      </Box>
      <Box mt={2} display="flex" justifyContent="center">
        <Button variant="contained" onClick={() => handleSubmit(text, color)}>
          Aceptar
        </Button>
      </Box>
    </Box>
  );
}

const Props = {
  handleSubmit: propTypes.func,
};

NewStatePopup.propTypes = Props;

export default NewStatePopup;
